import React, { Fragment } from 'react'

export default ({ subscribe, hash }) => {
    return (
        <Fragment>
            <h1>We’re sad to see you go</h1>
            <div>
                Your email address has been removed from our subscription list.<br/>
                Please allow 48 hours for your changes to take effect.
            </div>
            <div className="subscribe-action">
                <h3>Didn't mean to unsubscribe?</h3>
                <button className="subscribe-button"  onClick={() => subscribe(hash)}>Sign me back up!</button>
            </div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/subscribe/success.js